export const icemunmunModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('icemunmun') !== -1) {
			return {
				type: 'icemunmunModsTest',
				color: 'IndianRed',
				title: 'Outdated mods by icemunmun',
				text: 'You\'re potentially using an outdated mod made by icemunmun.',
				description: 'Remove and update all files related to the <strong>icemunmun</strong> creator.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>8d1d99f2b64b5fc25bcf96dc</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-10-23 17:47:57</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>tunable_model.py:71</categoryid>
        <desyncid>8d1d99f2b64b5fc25bcf96dc</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[cjiang] Error while parsing tuning in Instance: 16432541386966100398 (icemunmun:Object_Food_Homestyle_HalloweenFangCookie_Multi), Types.OBJECT: (AttributeError: 'NoneType' object has no attribute 'get_model')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 144, in _execute_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 433, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 658, in load_from_xml
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 703, in feed
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 747, in _load_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 796, in _load_tunable
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1429, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1735, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1446, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1429, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 820, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 822, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 523, in __call__
  File &quot;T:\InGame\Gameplay\Scripts\Server\tunable_utils\tunable_model.py&quot;, line 75, in _factory
  File &quot;T:\InGame\Gameplay\Scripts\Server\tunable_utils\tunable_model.py&quot;, line 71, in get_model
AttributeError: 'NoneType' object has no attribute 'get_model'
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/icemunmunModsTest.js